import type { TableColumn } from '@swf/poker';
import { CELL_START_STATE, columns as baseColumns } from '@swf/poker';

import { rowStateTimeComparator } from '../../../utils';

import TableCellPPState from './TableCellState';

export const columns: TableColumn[] = [
  {
    ...CELL_START_STATE,
    width: 160,
    Cell: TableCellPPState,
    sortType: rowStateTimeComparator
  },
  ...baseColumns.slice(1)
];

export default columns;
